<template>
  <div class="submenu d-flex justify-center">
    <div class="submenu-container w-100">
      <div class="ml-4 mt-4 w-25 d-flex" :style="{ height: '20px' }">
        <img
          src="@/assets/png/payscale-dark.png"
          alt="Job nav Logo"
        >
      </div>

      <div class="w-50 d-flex ml-12">
        <v-btn
          class="text-button-2 my-auto pa-0 mr-6"
          variant="plain"
        >
          <SimilarJobs
            v-if="!sideBySideView && !authData.nextUiEnabled"
            :job-id="jobId"
          />
        </v-btn>
        <v-dialog
          v-if="!sideBySideView && isEditable && documentType === 'job' && !hideApplyTemplate"
          v-model="applyTemplateModalVisible"
          width="350"
        >
          <template #activator="{ props }">
            <v-btn
              class="text-button-2 my-auto pa-0"
              variant="plain"
              v-bind="props"
            >
              Apply Template
            </v-btn>
          </template>
          <ApplyTemplateModal
            :job-id="jobId"
            :revision-id="currentRevisionId"
            @tracking-event="$emit('tracking-event', $event)"
          />
        </v-dialog>

        <TranslateJobButton
          v-if="!sideBySideView"
          spaced
        />

        <FirstDraftButtonForSubmenu
          v-if="aiEnabled && !sideBySideView"
          class="my-auto pa-0 ml-6"
        />
      </div>

      <div class="w-25 d-flex justify-end">
        <SideBySideSubMenuButtons
          v-if="sideBySideView"
          class="d-flex align-center ml-12"
          :job-id="jobId"
        />
        <template v-else>
          <SimilarJobsToggle
            v-if="authData.nextUiEnabled"
            class="pr-2 my-auto"
          />
          <HistoryToggle
            class="pr-2 my-auto"
          />
          <CommentsToggle
            class="pr-2 my-auto"
          />
        </template>
        <div class="close-button-placeholder ml-4 d-flex flex-column justify-center">
          <DpplAutoSizedButton
            v-if="!sideBySideView"
            class="ml-1 mb-1"
            :disabled="isRevisionSaving"
            width="108"
            @click="onCloseClick"
          >
            Save & Close
          </DpplAutoSizedButton>
        </div>
      </div>
    </div>
    <TranslateJobModal />
  </div>
</template>
<script>
import { mapState } from 'pinia';
import ApplyTemplateModal from '@/components/shared/ApplyTemplateModal.vue';
import TranslateJobButton from '@/components/editor/TranslateJobButton.vue';
import TranslateJobModal from '@/components/shared/TranslateJobModal.vue';
import SideBySideSubMenuButtons from '@/components/editor/SideBySideSubMenuButtons.vue';
import { useAppSideNav } from '@/stores/app/appSideNav';

// TODO: remove after new similar jobs implementation is complete
import SimilarJobs from '@/components/editor/SimilarJobs.vue';

import { useAppAuthData } from '@/stores/app/authData';
import { useDatapeopleAnywhereEditor } from '@/stores/document/datapeopleAnywhereEditor';
import { useEditor } from '@/stores/editor/editor';
import { useApplyTemplate } from '@/stores/document/applyTemplate';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import { closeExtensionWindow } from '@/helpers/extensionMessaging';
import HistoryToggle from '@/components/document/rightPanel/HistoryToggle.vue';
import CommentsToggle from '@/components/document/rightPanel/CommentsToggle.vue';
import SimilarJobsToggle from '@/components/document/rightPanel/SimilarJobsToggle.vue';
import FirstDraftButtonForSubmenu from '@/components/firstDraft/FirstDraftButtonForSubmenu.vue';

export default {
  name: 'ChromeNavbar',
  components: {
    DpplAutoSizedButton,
    ApplyTemplateModal,
    SideBySideSubMenuButtons,
    TranslateJobButton,
    TranslateJobModal,
    SimilarJobs, // TODO: remove after new similar jobs implementation is complete
    HistoryToggle,
    CommentsToggle,
    FirstDraftButtonForSubmenu,
    SimilarJobsToggle,
  },
  props: {
    jobId: { type: [String, Number], default: '' },
    allRevisions: { type: Array, default: () => [] },
    currentRevisionId: { type: Number, default: null },
  },
  emits: ['tracking-event'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
    ...mapState(useDatapeopleAnywhereEditor, ['isDatapeopleAnywhereEditor']),
    ...mapState(useEditor, [
      'isRevisionSaving', 'sideBySideView', 'isEditable', 'documentType', 'isTapwageIntegration', 'jobStatusLabel',
    ]),
    ...mapState(useAppSideNav, ['isSideNavOpen']),
    sideRevision() {
      return this.$route.query.sideRevision;
    },
    applyTemplateModalVisible: {
      get() {
        return useApplyTemplate().modalVisible;
      },
      set(visible) {
        useApplyTemplate().setModalVisible(visible);
      },
    },
    aiEnabled() {
      return this.authData.aiEnabled;
    },
    hideApplyTemplate() {
      return this.isTapwageIntegration && ['Open', 'Unpublished'].includes(this.jobStatusLabel);
    },
  },
  watch: {
    sideBySideView: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          window.parent.postMessage('hideCloseButton', '*');
        } else {
          window.parent.postMessage('showCloseButton', '*');
        }
      },
    },
  },
  mounted() {
    this.isSideNavOpen = false;
  },
  methods: {
    onCloseClick() {
      closeExtensionWindow();
    },
  },
};
</script>
<style scoped lang="less">
.submenu {
  width: 100%;
  height: 56px;
  z-index: 10;
  background-color: @white;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;

  .submenu-container {
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding-left: 44px;
    padding-right: 44px;
    .close-button-placeholder {
      width: 108px;
    }
  }
}
.submenu {
  :deep(.clickable) {
    cursor: pointer;
  }
  :deep(a) {
    color: color(@text-darkest);
    text-decoration: none;
  }
}
</style>
